import { NavLink } from "react-router-dom";
import Breadcumbs from "../../components/Breadcumbs";
import DataFetcherTemplate from "../../hooks/fetchTemplate";
import BannerGeneral from "../../components/BannerGeneral";
import BlockImageCabecera from "../../components/BlockImageCabecera";

import ConectUs from "../../components/ConectUs";
import Notification from "../../components/Notification";
import BlockLeftImage from "../../components/BlockLeftImage";
import Quote from "../../components/Quote";
import calendario from "../../img/iconsoferta/calendario.png";
import modalidad from "../../img/iconsoferta/modalidad.png";
import titulo from "../../img/iconsoferta/titulo.png";
import sale from "../../img/iconsoferta/sale.png";

import inicio from "../../img/iconsoferta/inicio.png";
import { DistanciaNuevosFixed } from "../../components/Pasos";
import Block5Columns from "../../components/Block5Columns";
import Block3Columns from "../../components/Block3Columns";
import BlockBackgroundImage from "../../components/BlockBackgroundImage";
import BlockRightImage from "../../components/BlockRightImage";
import EnLineaPagos from "../../components/Enlineapagos";
import AccordionFromHtml from "../../components/Accordionfromhtml";
import TecPagos from "../../components/TecPagos";
const url = "https://tec.utpl.edu.ec";
function TecCreacionPresencial() {
  const DataDisplay = ({ data }) => (
    <>
      <div>
        {data.map((item, index) => (
          <div>
            <div className="relative">
              <BlockImageCabecera
                src={url + item.field_imagen_template}
                title={
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_texto_portada,
                      }}
                    />
                  </>
                }
              ></BlockImageCabecera>
              <DistanciaNuevosFixed></DistanciaNuevosFixed>
            </div>

            <div className="lightbluebg">
              <Breadcumbs
                content={
                  <>
                    <NavLink to="/tecnologias">Tecnologías</NavLink>
                    <span class="material-icons">chevron_right</span>
                    <NavLink to="/tecnologia-audiovisual">
                      Tecnología Superior en Creación Audiovisual Digital
                    </NavLink>
                  </>
                }
              ></Breadcumbs>
              <div className="padding oferta-icons">
                <p
                  className="layout8"
                  dangerouslySetInnerHTML={{
                    __html: item.field_carrera_resolucion,
                  }}
                />

                <Block5Columns
                  col1={
                    <>
                      <img src={titulo}></img>
                      <p>
                        <b>Título</b>
                      </p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_titulo,
                        }}
                      />
                    </>
                  }
                  col2={
                    <>
                      <img src={modalidad}></img>
                      <p>
                        <b>Modalidad</b>
                      </p>{" "}
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_modalidad,
                        }}
                      />{" "}
                    </>
                  }
                  col3={
                    <>
                      <img src={calendario}></img>
                      <p>
                        <b>Duración</b>
                      </p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_duracion,
                        }}
                      />
                    </>
                  }
                  col4={
                    <>
                      <img src={sale}></img>

                      <p>
                        <b>Inversión</b>
                      </p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_costo,
                        }}
                      />
                      <a
                        className="link-with-arrow fontsize10pt"
                        href="#descuentos"
                      >
                        Accede a becas y descuentos
                      </a>
                    </>
                  }
                  col5={
                    <>
                      <img src={inicio}></img>
                      <p>
                        <b>Fecha de inicio</b>
                      </p>{" "}
                  
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_fecha_inicio,
                        }}
                      />
                    </>
                  }
                ></Block5Columns>
              </div>
            </div>     <a href="https://utpl.edu.ec/validacion-tecnologias">
              {" "}
              <img src="https://www.utpl.edu.ec/carreras/sites/default/files/banner-rec.png"></img>{" "}
            </a>

            <div className="margin">
              <Block3Columns
                col1={
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_descripcion_tec,
                      }}
                    />{" "}
                  </>
                }
                col2={
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_descripcion1,
                      }}
                    />{" "}
                  </>
                }
                col3={
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_descripcion2,
                      }}
                    />{" "}
                  </>
                }
              ></Block3Columns>
            </div>
            <Quote
              content={
                <>
                  {" "}
                  <p
                    dangerouslySetInnerHTML={{
                      __html: item.field_atributo2,
                    }}
                  />
                </>
              }
            >
            </Quote>

            <div id="perfil">
              <BlockBackgroundImage
                src={url + item.field_imagen_perfil_profesional}
                content={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_perfil_profesional,
                    }}
                  />
                }
              ></BlockBackgroundImage>
            </div>

            <div className="layout8 padding" id="malla">
              <div
                className="width700"
                dangerouslySetInnerHTML={{
                  __html: item.field_malla_titulo,
                }}
              />
              <div className="layout6">
                <AccordionFromHtml htmlContent={item.field_malla}>
                  {" "}
                </AccordionFromHtml>
              </div>
            </div>
       
            <div className="margin" id="descuentos">
              <TecPagos></TecPagos>
            </div>
            <Quote
              content={
                <>
                  {" "}
                  <p
                    dangerouslySetInnerHTML={{
                      __html: item.field_atributo1,
                    }}
                  />
                </>
              }
            ></Quote>
            <div className="icon300 padding lightbluebg">
              <BlockRightImage
                src={url+item.field_imagen_docente}
                content={
                  <>
                    <p className="iconsize20">📣</p>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_texto_docente,
                      }}
                    />
                  </>
                }
              ></BlockRightImage>
            </div>
               <Quote
              content={
                <>
                  {" "}
                  <p
                    dangerouslySetInnerHTML={{
                      __html: item.field_atributo3,
                    }}
                  />
                </>
              }
            >
            </Quote>
          </div>
        ))}
      </div>
    </>
  );

  return (
    <>
      <DataFetcherTemplate url="https://tec.utpl.edu.ec/tec-audiovisual-presencial">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>

      <BannerGeneral></BannerGeneral>
    </>
  );
}

export default TecCreacionPresencial;
